import { render, staticRenderFns } from "./NumberSettings.vue?vue&type=template&id=7e50bc5c&scoped=true"
import script from "./NumberSettings.vue?vue&type=script&lang=js"
export * from "./NumberSettings.vue?vue&type=script&lang=js"
import style0 from "./NumberSettings.vue?vue&type=style&index=0&id=7e50bc5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e50bc5c",
  null
  
)

export default component.exports